import axios from '../base/axios';
import API_KEY from './key';

const GET_HISTORY = 'flixfrenzy/redux/GET_HISTORY';

// eslint-disable-next-line default-param-last
const historyReducer = (state = [], action) => {
  switch (action.type) {
    case GET_HISTORY:
      return action.payload;
    default:
      return state;
  }
};

export const getHistory = () => (dispatch) => {
  axios.get(`discover/movie?api_key=${API_KEY}&with_genres=36`).then((res) => {
    dispatch({
      type: GET_HISTORY,
      payload: res.data,
    });
  });
};

export default historyReducer;
